<template lang="pug">
  Popup(:visible="visible")
    .new-user-popup-container
      .beginner-order-window(
        v-if="popupKey === POPUP_WINDOW_KEY.beginner_order_window"
        :style="{ backgroundImage: `url(${info.popupBg})` }"
      )
        .popup-close(@click="handleClose")
        .popup-title
          HighlightText(
            :text="info.title"
            :highlightStyle="highlightStyle"
            :normalStyle="normalStyle"
          )
        .popup-info
          .info-number1 {{ info.price }}
          .info-number2 {{ info.rewardAmount }}

      .beginner-order-window-v2(
        v-if="popupKey === POPUP_WINDOW_KEY.beginner_order_window_v2"
        :style="{ backgroundImage: `url(${info.popupBg})` }"
      )
        .popup-close(@click="handleClose")

      .popup-btn(
        v-flash="{ boom: true, shineLight: false }"
        :class="{ 'popup-btn-v2': popupKey === POPUP_WINDOW_KEY.beginner_order_window_v2 }"
        @click="handleBtnClick"
      )
        span.btn-text {{ info.btnText }}
</template>

<script>
import { debounce } from '@/utils';
import Popup from '@/components/popup';
import HighlightText from '@/components/highlight-text';
import SPM from '../common/spm';
import { POPUP_WINDOW_KEY } from '../consts';

export default {
  name: 'NewUserPopup',
  components: {
    Popup,
    HighlightText,
  },
  props: {
    // 弹窗是否显示
    visible: {
      type: Boolean,
      required: true,
      default: false,
    },
    // 弹窗信息
    info: {
      type: Object,
      required: true,
      default: () => {},
    },
    // 弹窗类型
    popupKey: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      // 弹窗类型
      POPUP_WINDOW_KEY,
    };
  },
  computed: {
    highlightStyle() {
      return {
        fontSize: '0.13rem',
        color: '#ffedb2',
      };
    },
    normalStyle() {
      return {
        fontSize: '0.13rem',
        color: '#fff',
      };
    },
  },
  watch: {
    visible(val) {
      if (val) {
        SPM.moduleExpose({
          moduleId: 'Welfare_New_pop',
          contentId: 'Welfare_New_pop',
          businessInfo: {
            code: this.popupKey,
          },
        });
      }
    },
  },
  mounted() {},
  methods: {
    handleClose() {
      this.$emit('close');
    },
    handleBtnClick: debounce(function exec() {
      this.$emit('btnClick');
      SPM.clickButton({
        buttonName: 'Welfare_New_pop',
        businessInfo: {
          code: this.popupKey,
        },
      });
    }, 300),
  },
};
</script>

<style lang="less" scoped>
.new-user-popup-container {
  display: flex;
  flex-direction: column;
  align-items: center;

  .popup-close {
    position: absolute;
    width: 0.22rem;
    height: 0.22rem;
    background-image: url(https://m.hellobike.com/resource/gallery/866/RLiFpN-DcN.png);
    background-size: 100% 100%;
    background-repeat: no-repeat;
  }

  .popup-btn {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 0.26rem;
    padding: 0 0.1rem;
    width: 1.02rem;
    height: 0.34rem;
    background-image:
      linear-gradient(
        97.55deg,
        #ff8356 17.28%,
        #ff334b 51.38%,
        #f93a71 90.27%
      );
    border-radius: 0.21rem;
    box-sizing: border-box;

    .btn-text {
      font-weight: 500;
      font-size: 0.16rem;
      color: #fff;
      line-height: normal;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

  .popup-btn-v2 {
    margin-top: 0.23rem;
    padding: 0 0.18rem;
    width: 1.46rem;
    height: 0.5rem;
    border-radius: 0.3rem;

    .btn-text {
      font-size: 0.22rem;
    }
  }
}

.beginner-order-window {
  position: relative;
  padding: 0.51rem 0.17rem 0 0.14rem;
  width: 2.46rem;
  height: 1.88rem;
  background-size: 100% 100%;
  background-repeat: no-repeat;

  .popup-close {
    top: -0.1rem;
    right: 0.01rem;
  }

  .popup-title {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 0.47rem;
  }

  .popup-info {
    position: relative;
    width: 2.15rem;
    height: 0.67rem;

    .info-number1 {
      position: absolute;
      top: 0.09rem;
      left: 0.25rem;
      font-family: DINAlternate-Bold, DINAlternate, sans-serif;
      font-size: 0.22rem;
      color: #ff344c;
    }

    .info-number2 {
      display: flex;
      justify-content: center;
      position: absolute;
      top: 0.09rem;
      right: 0;
      width: 0.6888rem;
      font-family: DINAlternate-Bold, DINAlternate, sans-serif;
      font-size: 0.22rem;
      color: #ff344c;
    }
  }
}

.beginner-order-window-v2 {
  position: relative;
  width: 2.97rem;
  height: 2.69rem;
  background-size: 100% 100%;
  background-repeat: no-repeat;

  .popup-close {
    top: 0.14rem;
    right: 0.01rem;
  }
}
</style>
